export function cocokCariPasien(
  term: string | null | undefined,
  nilai: Array<string | number | null | undefined>
): boolean {
  const q = (term || "").trim().toLowerCase();
  if (!q) return true;

  return nilai.some(v => v !== null && v !== undefined && String(v).toLowerCase().includes(q));
}
